module.exports = __webpack_public_path__ + "static/mobile-3-1bde8c5e0c5a6cc89dd84561e5274777.png";